import moment from 'moment';

export const dateInputUtils = {
  toMoment(
    type: 'from' | 'to' | 'date-only',
    raw: string | undefined
  ): moment.Moment | undefined {
    if (!raw) return undefined;

    if (type === 'date-only') {
      return moment(raw, 'YYYY-MM-DD');
    }

    const date = moment(raw, moment.ISO_8601);
    return date;
  },
  toString(
    type: 'from' | 'to' | 'date-only',
    raw: moment.Moment | undefined | null
  ): string | undefined {
    if (!raw) return undefined;

    // Convertiamo la data nella TimeZone di interesse per l'applicativo
    const date = moment(raw.format('DD/MM/YYYY'), 'DD/MM/YYYY');

    // console.log('tz', date.tz());
    // console.log(
    //   'date',
    //   raw.format('DD/MM/YYYY'),
    //   raw.toISOString(),
    //   type === 'start'
    //     ? date.startOf('day').toISOString()
    //     : date.endOf('day').toISOString()
    // );

    switch (type) {
      case 'from':
        return date.startOf('day').toISOString();
      case 'to':
        return date.endOf('day').toISOString();
      case 'date-only':
        return date.format('YYYY-MM-DD');
    }
  }
};
